/** Geometrie fürs maßstäbliche Zeichnen – alle Werte in cm, y zeigt nach oben. */

export function radius(sehne: number, stich: number): number {
  return stich / 2 + (sehne * sehne) / (8 * stich);
}

/** SVG-Pfad eines Bogens über der Sehne (Endpunkte ±s/2 auf y=0, Scheitel bei y=−h). */
export function bogenPfad(sehne: number, stich: number): string {
  const r = radius(sehne, stich);
  const gross = stich > sehne / 2 ? 1 : 0;
  return `M ${-sehne / 2} 0 A ${r} ${r} 0 ${gross} 1 ${sehne / 2} 0`;
}

/** Konzentrischer Bogen im Abstand `abstand` außerhalb, gleicher Mittelpunktswinkel. */
export function aussenBogenPfad(sehne: number, stich: number, abstand: number): string {
  const r1 = radius(sehne, stich);
  const r = r1 + abstand;
  const cy = r1 - stich; // Mittelpunkt (0, cy) in Bildschirm-y (nach unten positiv)
  const theta = Math.asin(Math.min(1, sehne / (2 * r1)));
  const x = r * Math.sin(theta);
  const y = cy - r * Math.cos(theta);
  const gross = stich > sehne / 2 ? 1 : 0;
  return `M ${-x} ${y} A ${r} ${r} 0 ${gross} 1 ${x} ${y}`;
}

/** Stich einer Teilsehne auf demselben Kreis. */
export function stichVon(sehne: number, radiusCm: number): number {
  return radiusCm - Math.sqrt(Math.max(0, radiusCm * radiusCm - (sehne * sehne) / 4));
}
